import { addActiveFilter, changePage } from '@frontend/repository';
import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { resolveSearchKeyDisplayName } from '../search-key-display-names';
import { InsaneSearchProps } from './insane-search.component';

export const useInsaneSearch = (props: InsaneSearchProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const regex = (value: string) => (value.charAt(0).toUpperCase() + value.replace(/_/g, ' ').slice(1)).replace(/_/g, ' ');
    const options = useMemo(() => {
        return props.searchKeys.map((key) => ({
            value: key,
            label: regex(key),
            display: resolveSearchKeyDisplayName(key, props.displayName)
        }));
    }, [props.searchKeys, props.displayName]);

    const [value, setValue] = useState<string | null>(null);
    const [selectOption, setSelectOption] = useState(options[0].value);

    function updateSearchParams(key: string, value: string) {
        const params = new URLSearchParams(searchParams);
        // Use set() to replace any existing values for this key, matching the Redux behavior
        // where addActiveFilter replaces the filter array when a string value is passed
        params.set(key, value);
        setSearchParams(params);
    }

    function onChange() {
        if (!value || value.length === 0 || value === '' || !props.listStore) return;
        if (props.listStore.activeFilters && props.listStore.activeFilters[selectOption] && props.listStore.activeFilters[selectOption].includes(value)) return;
        props.dispatch(addActiveFilter({ listId: props.listId, key: selectOption, value }));
        // Reset page index to 0 when a new search/filter is applied
        props.dispatch(changePage({ listId: props.listId, page: 0 }));
        updateSearchParams(selectOption, value);
        setValue('');
    }

    return {
        options,
        value,
        selectOption,
        setValue,
        setSelectOption,
        onChange
    };
};
